module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/character/character-sheet/character-sheet-fiction/character-sheet-fiction.component.css
// module id = ./src/app/character/character-sheet/character-sheet-fiction/character-sheet-fiction.component.css
// module chunks = main